import axios from './index'

class pullnew{
    static scanPush(options) {
        return axios.get(`/nice-api-order/v1/survey/scanPush/${options.orderId}`)
    }

    static getCoupon(options) {
        return axios.get(`/nice-api-customer/v1/channelPullNewCustomer/backendConfigCoupon/${options.utmSource}`)
    }
    static sendSms(options) {
        return axios.post(`/nice-api-customer/v1/login/sendSms`,options)
    }
    static receiveCoupon(options) {
        return axios.post(`/nice-api-customer/v1/channelPullNewCustomer/drawAward`,options)
    }

    static getSurvey(options) {
        return axios.get(`/nice-api-order/v1/survey/${options.id}`,options)
    }

    static submitSurvey(options) {
        return axios.post(`/nice-api-order/v1/survey/submit`,options)
    }
}
export default pullnew;